var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#657D97",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2985_1311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4286 9.15527e-05H2.57143C1.15127 9.15527e-05 0 1.15136 0 2.57152V16.2858C0 17.706 1.15127 18.8572 2.57143 18.8572H5.6143L5.14803 23.0487C5.09605 23.5192 5.43535 23.9427 5.90589 23.9947C6.02603 24.008 6.14761 23.9957 6.26266 23.9586C6.37771 23.9216 6.48362 23.8607 6.57346 23.7798L12.0437 18.8572H21.4286C22.8487 18.8572 24 17.706 24 16.2858V2.57152C24 1.15136 22.8487 9.15527e-05 21.4286 9.15527e-05Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2985_1311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.af0b11d438a6895a21a9d59622e2607e.svg";
export { ForwardRef as ReactComponent };